import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { ProductContext } from "@insite/client-framework/Components/ProductContext";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import {
    getProductInfoFromList,
    getProductsForProductInfoList,
} from "@insite/client-framework/Store/Components/ProductInfoList/ProductInfoListSelectors";
import { getProductStateByPath } from "@insite/client-framework/Store/Data/Products/ProductsSelectors";
import { getPageLinkByNodeId, LinkModel, mapLinks } from "@insite/client-framework/Store/Links/LinksSelectors";
import translate from "@insite/client-framework/Translate";
import { HasFields } from "@insite/client-framework/Types/ContentItemModel";
import { LinkFieldValue } from "@insite/client-framework/Types/FieldDefinition";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Button from "@insite/mobius/Button";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import Hidden from "@insite/mobius/Hidden";
import LazyImage from "@insite/mobius/LazyImage";
import Typography from "@insite/mobius/Typography";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import intLoadProductsWithIds from "@tIntermatic/Handlers/IntLoadProductsWithIds";
import React, { useState } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

const enum fields {
    productsListId = "productsListId",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.productsListId]: string;
    };
}
export const productsListGLPStyles = {
    mainContainer: {
        css: css`
            border: 1px solid #e1e1e1;
            background-color: #ffffff;
            max-width: 1140px;
            display: flex;
            padding-top: 20px;
            margin: 25px 0;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        flex-direction: column;
                    `,
                    css`
                        flex-direction: column;
                    `,
                    css`
                        flex-direction: column;
                    `,
                    css`
                        flex-direction: row;
                    `,
                    css`
                        flex-direction: row;
                    `,
                ])},
        `,
    },
    imageWrapper: {
        css: css`
            display: flex;
            flex-direction: column;
            flex: 0.352;
            padding-left: 8px;
        `,
    },
    productDetailsWrapper: {
        css: css`
            display: flex;
            flex-direction: column;
            flex: 1;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        padding: 0 20px;
                    `,
                    css`
                        padding: 0 20px;
                    `,
                    css`
                        padding: 0 20px;
                    `,
                    null,
                    null,
                ])},
        `,
    },

    productTitle: {
        css: css`
            font-size: 21px;
            font-weight: 600;
            letter-spacing: 0;
            line-height: 25px;
            color: #33333a;
            display: block;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        padding: 10px 0 14px 0;
                    `,
                    css`
                        padding: 10px 0 14px 0;
                    `,
                    css`
                        padding: 10px 0 14px 0;
                    `,
                    css`
                        padding: 10px 0;
                    `,
                    css`
                        padding: 10px 0;
                    `,
                ])},
        `,
    },
    productModelNumber: {
        css: css`
            color: #006bc0;
            font-size: 14px;
            font-weight: 500;
            letter-spacing: 0;
            line-height: 17px;
            display: block;
            padding-bottom: 5px;
        `,
    },
    prouductDescription: {
        css: css`
            color: #33333a;
            font-size: 14px;
            letter-spacing: 0;
            line-height: 25px;
            display: block;

            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        padding-right: 0;
                    `,
                    css`
                        padding-right: 0;
                    `,
                    css`
                        padding-right: 0;
                    `,
                    css`
                        padding-right: 52px;
                    `,
                    css`
                        padding-right: 52px;
                    `,
                ])},
        `,
    },

    button: {
        css: css`
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        width: 100%;
                    `,
                    css`
                        width: 100%;
                    `,
                    css`
                        width: 100%;
                    `,
                    css`
                        padding: 0 47.74px;
                    `,
                    css`
                        padding: 0 47.74px;
                    `,
                ])},
                background: #313639 !important;
                border: 1px solid #313639  !important;
                &:hover {
                    border: 1px solid #010B13 !important;
                    background: #010B13 !important;
                }
                > span {
                    font-size: 12px;
                    letter-spacing: 2px;
                    line-height: 20px;
                    text-align: center;
                    color: #ffffff;
                    &:hover {
                        background: #000000 !important;
                        border-color: #000000 !important;
                }

                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                            font-weight: 500;
                        `,
                        css`
                            font-weight: 500;
                        `,
                        css`
                            font-weight: 500;
                        `,
                        css`
                            font-weight: bold;
                        `,
                        css`
                            font-weight: bold;
                        `,
                    ])},
            }
        `,
    },

    productImage: {
        css: css`
            padding: 0 61px;
        `,
    },
};

const mapStateToProps = (state: ApplicationState, ownProps: OwnProps) => ({
    products: getProductsForProductInfoList(state, ownProps.id),
});

const mapDispatchToProps = {
    intLoadProductsWithIds,
};

const styles = productsListGLPStyles;
type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

const INTProductListGLP = ({ id, fields, intLoadProductsWithIds, products }: Props) => {
    React.useEffect(() => {
        intLoadProductsWithIds({
            id,
            productidlist: fields.productsListId,
        });
    }, [fields.productsListId]);

    const redirect = (url: any) => {
        window.location.href = url;
    };

    const stripHTMLContent = (content: string | undefined) => {
        const stripedHtml = content?.replace(/<[^>]+>/g, "");
        const characterCount = stripedHtml ? stripedHtml?.trim().length : 0;
        return (
            <>
                {stripedHtml?.trim().substring(0, 213)}
                {characterCount > 213 ? <span>...</span> : null}
            </>
        );
    };
    return (
        <>
            <Hidden below="lg">
                <StyledWrapper>
                    {products?.map(product => (
                        <StyledWrapper key={product?.id} {...styles.mainContainer}>
                            <StyledWrapper {...styles.imageWrapper}>
                                <LazyImage src={product?.mediumImagePath} altText="image" />
                            </StyledWrapper>
                            <StyledWrapper {...styles.productDetailsWrapper}>
                                <StyledWrapper
                                    css={css`
                                        padding-left: 85px;
                                    `}
                                >
                                    <Typography {...styles.productTitle}>{product?.productTitle}</Typography>
                                    <Typography {...styles.productModelNumber}>
                                        {translate("Model #")} {product?.productNumber}
                                    </Typography>
                                    <Typography {...styles.prouductDescription}>
                                        {stripHTMLContent(product?.content?.htmlContent)}
                                    </Typography>
                                    <StyledWrapper
                                        css={css`
                                            padding: 15px 0;
                                        `}
                                    >
                                        <Button
                                            {...styles.button}
                                            // eslint-disable-next-line no-return-assign
                                            onClick={() => redirect(product?.canonicalUrl)}
                                        >
                                            SHOP NOW
                                        </Button>
                                    </StyledWrapper>
                                </StyledWrapper>
                            </StyledWrapper>
                        </StyledWrapper>
                    ))}
                </StyledWrapper>
            </Hidden>

            <Hidden above="md">
                <StyledWrapper
                    css={css`
                        margin: 0 -25px;
                    `}
                >
                    {products?.map(product => (
                        <StyledWrapper key={product?.id} {...styles.mainContainer}>
                            <StyledWrapper>
                                <LazyImage {...styles.productImage} src={product?.mediumImagePath} altText="image" />
                            </StyledWrapper>
                            <StyledWrapper {...styles.productDetailsWrapper}>
                                <Typography {...styles.productTitle}>{product?.productTitle}</Typography>
                                <Typography {...styles.productModelNumber}>{translate("Model #")} {product?.productNumber}</Typography>
                                <Typography {...styles.prouductDescription}>
                                    {stripHTMLContent(product?.content?.htmlContent)}
                                </Typography>
                                <StyledWrapper
                                    css={css`
                                        padding: 9px 0 25px 0;
                                    `}
                                >
                                    <Button
                                        {...styles.button}
                                        // eslint-disable-next-line no-return-assign
                                        onClick={() => redirect(product?.canonicalUrl)}
                                    >
                                        SHOP NOW
                                    </Button>
                                </StyledWrapper>
                            </StyledWrapper>
                        </StyledWrapper>
                    ))}
                </StyledWrapper>
            </Hidden>
        </>
    );
};
const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(INTProductListGLP),
    definition: {
        group: "Common",
        icon: "List",
        displayName: "INTProductListGLP",
        fieldDefinitions: [
            {
                name: fields.productsListId,
                displayName: "Products List Ids",
                editorTemplate: "TextField",
                defaultValue: "",
                fieldType: "General",
                sortOrder: 0,
            },
        ],
    },
};

export default widgetModule;
